import React, { useEffect, useState } from 'react';
import { canAccessFeedbackPanel, canAccessDebugPanel, isSuperAdmin, isAdmin, isTester } from '../utils/userRoles';
import './FeedbackTrigger.css';

const FeedbackTrigger = ({ onToggle, isOpen, user, profile }) => {
  // All hooks must be called before any conditional logic
  const userRole = profile?.user_role;
  const hasAccess = canAccessFeedbackPanel(userRole);
  const hasDebugAccess = canAccessDebugPanel(userRole);

  // Only show for testers (not admins or super admins)
  if (!hasAccess || !isTester(userRole)) {
    return null;
  }

  const handleClick = () => {
    onToggle();
    
    // Log the action if debug logging is available
    if (window.adminDebug) {
      window.adminDebug.addLog(`Feedback panel ${!isOpen ? 'opened' : 'closed'} by ${userRole}`, 'system', {
        user_id: user?.sub,
        user_role: userRole,
        timestamp: new Date().toISOString()
      });
    }
  };

  const getTriggerIcon = () => {
    return '🔍'; // Magnifying glass for tester
  };

  const getTriggerTitle = () => {
    return 'Submit Feedback';
  };

  const getButtonClass = () => {
    let baseClass = 'feedback-trigger-btn';
    if (isOpen) baseClass += ' active';
    baseClass += ' tester';
    return baseClass;
  };

  return (
    <div className="feedback-trigger">
      <button
        onClick={handleClick}
        className={getButtonClass()}
        title={getTriggerTitle()}
      >
        {getTriggerIcon()}
      </button>
      <div className="feedback-trigger-tooltip">
        {getTriggerTitle()}
      </div>
    </div>
  );
};

export default FeedbackTrigger; 